import { render, staticRenderFns } from "./ContactBlockModal.vue?vue&type=template&id=daada838&scoped=true&"
import script from "./ContactBlockModal.vue?vue&type=script&lang=js&"
export * from "./ContactBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactBlockModal.vue?vue&type=style&index=0&id=daada838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daada838",
  null
  
)

export default component.exports